/**
 * Kullanıcının profil adres alanının dolu olup olmadığını güvenli şekilde kontrol eder.
 */
export function hasUserAddress(address) {
  if (address == null) {
    return false;
  }

  return String(address).trim().length > 0;
}

export default hasUserAddress;
